import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
export class GsapAnimations {
    constructor() {
        if (document.querySelector('.gsap-reveal')) {
            const revealContainers = gsap.utils.toArray('.gsap-reveal');
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const _this = this;
            gsap.set(revealContainers, { autoAlpha: 1 });
            revealContainers.forEach((container) => {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        toggleActions: 'restart none none reset',
                        onEnter: function () {
                            _this.animateFrom(container);
                        },
                    }
                });
            });
        }
        if (document.querySelector('.gsap-split-line')) {
            const headings = gsap.utils.toArray('.gsap-split-line');
            headings.forEach((heading) => {
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: heading,
                        toggleActions: 'restart none none reset'
                    }
                });
                const title = heading;
                const elements = title.querySelectorAll('span');
                tl.fromTo(elements, {
                    autoAlpha: 0,
                    transform: 'translate3d(0, 100%, 0)',
                }, {
                    duration: 0.75,
                    transform: 'none',
                    autoAlpha: 1,
                    ease: 'expo',
                    stagger: {
                        each: 0.06,
                        from: 'start'
                    }
                });
            });
        }
        if (document.querySelector('.gsap-fade-left-to-right')) {
            const carousels = gsap.utils.toArray('.gsap-fade');
            carousels.forEach((container) => {
                // const fadeLeftToRight = gsap.utils.toArray('.gsap-fade-left-to-right')
                const fadeLeftToRight = container.querySelectorAll('.gsap-fade-left-to-right');
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        toggleActions: 'restart none none reset'
                    }
                });
                tl.to(fadeLeftToRight, {
                    autoAlpha: 1,
                    x: 0,
                    stagger: {
                        each: 0.14,
                        ease: 'power3.out'
                    },
                    duration: 0.5
                });
            });
        }
    }
    animateFrom(elem, direction = 1) {
        let x = 0, y = direction * 100, animDelay = 0;
        if (elem.classList.contains('gsap-reveal-from-left')) {
            x = -100;
            y = 0;
        }
        else if (elem.classList.contains('gsap-reveal-from-right')) {
            x = 100;
            y = 0;
        }
        if (elem.hasAttribute('data-delay')) {
            animDelay = Number(elem.getAttribute('data-delay'));
        }
        if (elem.hasAttribute('data-fade')) {
            x = 0;
            y = 0;
        }
        if (elem.hasAttribute('data-transform-y')) {
            x = 0;
            y = direction * Number(elem.getAttribute('data-transform-y'));
        }
        elem.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        gsap.fromTo(elem, {
            x: x, y: y, autoAlpha: 0
        }, {
            duration: 0.75,
            x: 0,
            y: 0,
            autoAlpha: 1,
            ease: 'expo',
            overwrite: 'auto',
            delay: animDelay
        });
    }
}
